export const GRID_MAX_WIDTH = 85;
export const GRID_MAX_HEIGHT = 55;

export const GRID_RECOMMENDED_DIGITAL_WIDTH = 11;
export const GRID_RECOMMENDED_DIGITAL_HEIGHT = 11;
